import { useDispatch } from "react-redux";
import { setUser } from "../../features/auth/authSlice";
import { useNavigate } from "react-router";
import toast from "react-hot-toast";
import { motion, AnimatePresence } from "framer-motion";

const LogoutOverlay = ({ openLogout, handleOpenLogout, logoutRef }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async (e) => {
    e.stopPropagation();
    try {
      document.cookie = "token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "UserID=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";

      toast.success("Logged Out Successfully");

      dispatch(setUser({}));
      handleOpenLogout();
      navigate("/");
      window.location.reload();
    } catch (error) {
      toast.error("Logout Failed");
    }
  };

  return (
    <AnimatePresence>
      {openLogout && (
        <motion.div
          ref={logoutRef} // 👈 use the ref here
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black-1/60 flex items-center justify-center z-[9999]"
          onClick={handleOpenLogout}
        >
          <motion.div
            onClick={(e) => e.stopPropagation()}
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 25 }}
            className="w-[90%] max-w-sm bg-white-1 rounded-xl p-6 flex flex-col items-center shadow-xl"
          >
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Log out?</h3>
            <p className="text-sm text-gray-500 text-center mb-6">
              Are you sure you want to logout?
            </p>
            <div className="flex gap-4 w-full justify-center">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenLogout();
                }}
                className="flex-1 py-2 rounded-full bg-gray-200 text-gray-800 font-medium hover:bg-gray-300 hover:scale-105 transition-transform duration-200"
              >
                No
              </button>
              <button
                onClick={handleLogout}
                className="flex-1 py-2 rounded-full bg-gradient-to-r from-red-500 to-red-600 text-white font-medium hover:scale-105 transition-transform duration-200"
              >
                Yes
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};


export default LogoutOverlay;
